require('./../scss/main.scss');

// Shared JS imports
require('../../shared/js/preload');
require('../../shared/js/forms');
require('../../shared/js/url-query-to-cookie');
require('../../shared/js/image-fader');
require('../../shared/js/reverse-countdown');
require('../../shared/js/darkmode-favicon');
require('../../shared/js/fix-ios-100vh');
require('../../shared/js/cta-scroll-to-target');

// Require all js files in /js
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./non-critical/', true, /\.js$/));